import './BenefitsAdditionalContent.scss';

const BenefitsAdditionalContent = ({ data }) => {
  const imagesData = [
    {
      path: '/images/benefits/additional-content/flight.png',
      alt: 'Domestic Basic fares'
    },
    {
      path: '/images/benefits/additional-content/seats.png',
      alt: 'Seat inventory'
    },
    {
      path: '/images/benefits/additional-content/ancillary.png',
      alt: 'Discounted ancillary pricing'
    }
  ];
  if(!data){
    return null;
  }

  return (
    <section
      aria-labelledby="additional-content-id"
      className="benefits-additional-content"
    >
      <h2 className="title" id="additional-content-id">
        {data.title}
      </h2>
      <div className="container">
        {data.sections.map((section, index) => {
          return (
            <article className="content-item" key={`ben2-${section.id}`}>
              <img
                alt={imagesData[index].alt}
                aria-hidden
                src={process.env.PUBLIC_URL + imagesData[index].path}
              />
              <div className="container-title">{section.title}</div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default BenefitsAdditionalContent;
